import { useState } from 'react';
import { showModalError } from '../components/modals/modal-error';

export const useCopyClipboard = () => {
  const [copiedField, setCopiedField] = useState(null);

  const copyToClipboard = async (text, fieldName) => {
    if (!text) {
      showModalError({ errorMessage: 'No hay texto para copiar' });
      return;
    }

    try {
      await navigator.clipboard.writeText(text);
      setCopiedField(fieldName);
      setTimeout(() => {
        setCopiedField(null);
      }, 2000);
    } catch (err) {
      console.error('Error al copiar:', err);
      // Fallback para navegadores que no soportan clipboard API
      try {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        setCopiedField(fieldName);
        setTimeout(() => {
          setCopiedField(null);
        }, 2000);
      } catch (fallbackErr) {
        console.error('Error en fallback de copia:', fallbackErr);
        showModalError({ errorMessage: 'No se pudo copiar al portapapeles' });
      }
    }
  };

  return {
    copyToClipboard,
    copiedField,
  };
};
